import { render, staticRenderFns } from "./Consumptions.vue?vue&type=template&id=91708d58"
import script from "./Consumptions.vue?vue&type=script&lang=js"
export * from "./Consumptions.vue?vue&type=script&lang=js"
import style0 from "./Consumptions.vue?vue&type=style&index=0&id=91708d58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports